import React from "react";
import numeral from "numeral";
import { toggleArchivedDeadline } from "../../../store/actions/deadlines/company";
import { Dropdown, Menu, Select, Tooltip } from "antd";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../constants/constants";
import { isExpired, renderStatus } from "../../../libs/deadlinesUtils";
import { deadlineModePayment, deadlinePaymentTypes, deadlineSeenTypes, deadlineStatuses } from "../../../constants/scadenze";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  FormattedMessage } from "react-intl";
import moment from "moment";
const Option = Select.Option;

const buildMenuActionItems = (deadlineCurrent, dispatch) => {  
  const menuItems = [];
  if (isExpired(deadlineCurrent)) {
    const label = deadlineCurrent.status.archived ? (
      <FormattedMessage id="deadlines.showDeadline" />
    ) : (
      <FormattedMessage id="deadlines.hideDeadline" />
    );
    deadlineCurrent.id=deadlineCurrent.key;
    const archiveItem = (
      <Menu.Item
        onClick={() => {
          dispatch(toggleArchivedDeadline(
            deadlineCurrent,
            null,
            false
          ));
        }}
        key="toggleArchived"
      >
        <span> {label} </span>
      </Menu.Item>
    );
    menuItems.push(archiveItem);
  }
  return menuItems;
};
  
export const columnDef = (   
  intl, myType, setSolicitDeadlineId, setSolicitRagioneSociale, 
  onChangeFilter, hasMoreItems, queryParameters, customersView, 
  dispatch, companiesArray, navigate, setOpenSolicitDialog
) => [       
  {
    title:  intl.formatMessage({id: "deadlines.table.deadlineDate"}),
    dataIndex: "date",
    key: "date",
    render: (value, obj) => {        
      return (value === "initial" || value === "final"  ?  null :     
        <div 
          className={queryParameters?.specificDate ? "filterable active" : "filterable"}
          style={{
            minWidth: "140px",
            color:
            obj?.status?.confirmed !== true
              ? "#86899d"
              : ((obj?.payment?.status === "due" ||
              obj?.payment?.status === "suspended" ||
              obj?.status?.rejected) &&
              new Date(obj?.date) < new Date().setHours(
                0, 0, 0, 0
              )) ? 
                "rgb(216, 40, 41)"
                : "initial"            
          }}
          onClick={() => {            
            onChangeFilter(
              true, "specificDate", queryParameters?.specificDate ?  undefined : value
            );
          }}
        >
          {moment(value).format(DATE_FORMAT_FOR_DISPLAY)}
          <FontAwesomeIcon
            style={{ color: "#0090d1", margin: "5px" }}
            icon={["fal", queryParameters?.specificDate ? "times" : "filter"]}
          />
        </div>);
    }
    // sorter: (a, b) => { return a.date ==="initial" || b.date ==="initial" ? 0 : ((a.date > b.date) - (a.date < b.date));}
  },
  {
    title: intl.formatMessage({id: "deadlines.table.company"}),
    dataIndex: "itemId",
    key: "itemId",    
    hidden: customersView ? true : false,
    render: (value, obj) => {
      return value === "final" ? null : 
        value === "initial" ?  
          <Select
            className="theadSelect"
            style={{ margin: "8px" }}
            getPopupContainer={trigger => trigger.parentNode.parentNode}
            showSearch     
            allowClear={true}         
            placeholder={<FormattedMessage id="all"/>}
            optionFilterProp="children"
            filterOption={(input, option) =>  option.children?.props?.title?.toLowerCase().includes(input.toLowerCase())}
            filterSort={(optionA, optionB) => {              
              return optionA.children?.props?.title?.toLowerCase().localeCompare(optionB.children?.props?.title?.toLowerCase());
            }
            }
            onChange={(value) => {
              onChangeFilter(
                true, "itemId", value
              );
            }}
          >
            {
              companiesArray?.map(el => {
                return <Option key={el.uuid || el.id} value={el.uuid || el.id}>
                  <Tooltip
                    color="rgb(0, 80, 117)" 
                    getPopupContainer={trigger => trigger.parentNode.parentNode} 
                    title={el?.ragioneSociale}>
                    {el?.ragioneSociale}
                  </Tooltip></Option>;
              })
            }              
          </Select>
          : 
          <div style={{            
            color: obj?.status?.confirmed !== true
              ? "#86899d" :
              "initial"
          }}>{value}</div>;
    }
  },
  {
    title: intl.formatMessage({id: "deadlines.table.counterpart"}),
    dataIndex: "counterpart",
    key: "counterpart",    
    render: (value, obj) => {                     
      return (obj.key === "initial" || obj.key  === "-1" ?  null : 
        <div  
          style={{
            color: obj?.status?.confirmed !== true
              ? "#86899d" :
              "initial"
          }}
          className={["credit", "debt"].includes(obj.scope) && obj?.status?.confirmed && value?.taxId ? (queryParameters?.counterpartDescription ? "filterable active" : value?.taxId ? "filterable" : "") : ""}
          onClick={() => {        
            if (["credit", "debt"].includes(obj.scope) && obj?.status?.confirmed ){     
              if (value?.description) 
                onChangeFilter(
                  true, "counterpartDescription", queryParameters.counterpartDescription ? 
                    undefined : value?.description
                );
            }
          }}>
          {value?.description ? value?.description : "Non disponibile"}
          {["credit", "debt"].includes(obj.scope) && obj?.status?.confirmed && value?.taxId &&
              <FontAwesomeIcon
                style={{ color: "#0090d1", margin: "5px" }}
                icon={["fal", queryParameters?.counterpartDescription ? "times" : "filter"]}
              />
          }
        </div>);
    }
  },
  {
    title: intl.formatMessage({id: "deadlines.table.description"}),
    dataIndex: "description",
    key: "description",          
    textWrap: "word-break",    
    render: (value, obj) => (value === "initial" ? null : <div 
      className={["credit", "debt"].includes(obj.scope) && obj?.status?.confirmed && queryParameters?.sameAttachmentsAs ? "filterable active" : (["credit", "debt"].includes(obj.scope) && obj?.status?.confirmed) ? "filterable" : ""}
      onClick={() => {     
        if (["credit", "debt"].includes(obj.scope) && obj?.status?.confirmed){    
              
          /*  TODO capire perchè non va    */ 
          onChangeFilter(
            true, "sameAttachmentsAs", queryParameters.sameAttachmentsAs ? 
              undefined : obj.key
          );   
        }
      }}
      style={{                
        fontWeight: obj?.key === "-1" ? 700 : "inherit",
        color: obj?.status?.confirmed !== true && obj?.key !== "-1"
          ? "#86899d" :
          obj?.key === "-1" ?
            "#005075"
            :
            "initial"
      }}>{value}
      { ["credit", "debt"].includes(obj.scope) && obj?.status?.confirmed &&
      <FontAwesomeIcon
        style={{ color: "#0090d1", margin: "5px" }}
        icon={["fal", queryParameters?.sameAttachmentsAs ? "times" : "filter"]}
      />
      }
    </div>)
  },
  {
    title: intl.formatMessage({id: "deadlines.table.amount"}),
    dataIndex: "amount",
    align: "right",
    key: "amount",
    render: (value, obj) => {  
      const iconColor =
        obj?.status?.confirmed !== true && obj?.key !== "-1"
          ? "#86899d"
          : 
          value > 0
            ? "#0d6c80"
            : "#c53090";
      const iconTitle =
        value > 0 ? "plus-circle" : "minus-circle";
                      
      return (value === "initial" ?  null : 
        <div style={{
          minWidth: "150px",
          display: "flex", justifyContent: "space-between", 
          fontWeight: obj?.key === "-1" ? 700 : "inherit",
          color: obj?.status?.confirmed !== true && obj?.key !== "-1"
            ? "#86899d" :
            obj?.key === "-1" ?
              "#005075" :          
              "initial"}}>
          <FontAwesomeIcon
            style={{ color: iconColor, margin: "5px" }}
            icon={["fas", iconTitle]}
          />
          {numeral(Math.abs(value)).format("0,0.00") + " €"}</div>);
    }
  },
  {
    title: intl.formatMessage({id: "deadlines.table.paymentMode"}),    
    dataIndex: "paymentMode",
    key: "paymentMode",      
    render: (value, obj) => {   
                   
      return (
        value === "final" ?  null : 
          value === "initial" ? 
            <Select     
              className="theadSelect"
              getPopupContainer={trigger => trigger.parentNode.parentNode}
              style={{ maxWidth: "150px",  margin: "8px" }}
              allowClear={true}     
              showSearch={true}                   
              placeholder={<FormattedMessage id="all"/>}
              optionFilterProp="children"       
              filterOption={(input, option) =>{                   
                return intl.formatMessage({id: option.desc}).toLowerCase().includes(input.toLowerCase());
              }}
              filterSort={(optionA, optionB) => {
                intl.formatMessage({id: optionA.desc}).toLowerCase().localeCompare(intl.formatMessage({id: optionB.desc}).toLowerCase());
              }
              }        
              onChange={(value) => {
                onChangeFilter(
                  true, "paymentMode", value
                );
              }}
            >
              {
                deadlineModePayment.map(el => {
                  const tooltipDesc =  intl.formatMessage({id: el.desc});
                  return <Option key={el.key} value={el.key} desc={el.desc}>
                    <Tooltip
                      color="rgb(0, 80, 117)" 
                      getPopupContainer={trigger => {
                        return document.querySelector("tbody");
                      }} 
                      title={tooltipDesc}>
                      {tooltipDesc}
                    </Tooltip>                                   
                  </Option>;
                })
              }              
            </Select>           
            :
            obj?.payment?.mode?.id && obj.bankTransactionCount > 0 ?
              <span
                onClick={() =>
                  navigate(`/scadenza/${element.id}`,
                    {
                      state: { fromList: true }
                    })
                }
                style={{
                  cursor: "pointer",
                  display: "flex",
                  gap: "16px",
                  justifyContent: "center",
                  color: "#0090d1"
                }}
              >
                <span> <FormattedMessage id={`deadlines.payment.${obj?.payment?.mode?.id}`} /></span>
                <span>
                  <FontAwesomeIcon icon={["fas", "university"]} />
                </span>
              </span>
              :
              <div>{obj?.payment?.mode?.id && <FormattedMessage id={`deadlines.payment.${obj?.payment?.mode?.id}`} />}</div>
      );
    }      
  },
  {
    title: intl.formatMessage({id: "deadlines.table.management"}),
    dataIndex: "management",
    key: "management",
    align: "center",    
    render: (value, obj) => {     
      let colorIcon = "#152935";
      if (
        obj?.payment?.step === "unpaid" ||
            obj?.payment?.step === "suspended" ||
            obj?.payment?.step === "rejected"
      ) {
        colorIcon = "#d82829";
      } else if (
        obj?.payment?.step === "paid" ||
            obj?.payment?.step === "collected" ||
            obj?.payment?.step === "rebated" ||
            obj?.payment?.compensation
      ) {
        colorIcon = "#09822a";
      } else if (
        obj?.payment?.step === "to_be_paid" ||
            obj?.payment?.step === "to_be_collected" ||
            obj?.payment?.step === "authorized" ||
            obj?.payment?.status === "pending" ||
            obj?.payment?.status === "verified" ||
            obj?.payment?.status === "failed"
      ) {
        colorIcon = "#fdb927";
      }

      let stringType = "deadlines.pages.table.itemPays";
      let iconType = "user";

      if (obj?.payment?.type === "manager_charge" &&
        (obj?.status?.confirmed ||
            obj.scope !== "fiscal_social_security")){
        stringType = "deadlines.pages.table.managerCharge";
        iconType = "university";
      } else if (obj?.payment?.type === "manager_pays" &&
        (obj?.status?.confirmed ||
            obj.scope !== "fiscal_social_security")){
        stringType = "deadlines.pages.table.managerCharge";
        iconType = "briefcase";
      }
          
      return (
        value === "final" ? null : 
          value === "initial" ?
            <Select     
              className="theadSelect"
              getPopupContainer={trigger => trigger.parentNode.parentNode}
              style={{ margin: "8px" }}
              allowClear={true}                                 
              placeholder={<FormattedMessage id="all"/>}
              onChange={(value) => {
                onChangeFilter(
                  true, "paymentType", value
                );
              }}
            >
              {
                deadlinePaymentTypes.map(el => {                  
                  return <Option key={el.key} value={el.key} desc={el.desc}>
                    <Tooltip
                      color="rgb(0, 80, 117)" 
                      getPopupContainer={trigger => document.querySelector("tbody")} 
                      title={<span>{el.desc}</span>}>
                      <span>{el.desc}</span>
                    </Tooltip>
                  </Option>;
                })
              }              
            </Select>    :
            <div style={{align: "center"}}>
              <Tooltip
                getPopupContainer={trigger => trigger.parentNode.parentNode}
                color="rgb(0, 80, 117)"
                placement="top"
                arrowPointAtCenter={true}                
                title={
                  <FormattedMessage id={stringType} />
                }
              >
                <FontAwesomeIcon
                  icon={["fas", iconType]}
                  style={{ color: colorIcon }}
                />
              </Tooltip>
            </div>
      );
    }    
      
  },
  {
    title: intl.formatMessage({id: "deadlines.table.status"}),
    dataIndex: "status",
    key: "status",
    width: "130",
    render: (value, obj) => {    
      if (value === "final"){
        return null;
      }          
      if (value === "initial") {
        return <Select    
          className="theadSelect"
          mode={"multiple"}
          maxTagCount={1} 
          getPopupContainer={trigger => trigger.parentNode.parentNode}
          style={{ width: "130px",  margin: "8px" }}
          allowClear={true}     
          showSearch={true}                   
          placeholder={<FormattedMessage id="all"/>}
          optionFilterProp="children"       
          filterOption={(input, option) =>{                   
            return intl.formatMessage({id: option.desc}).toLowerCase().includes(input.toLowerCase());
          }}
          filterSort={(optionA, optionB) => {
            intl.formatMessage({id: optionA.desc}).toLowerCase().localeCompare(intl.formatMessage({id: optionB.desc}).toLowerCase());
          }
          }        
          onChange={(value) => {            
            onChangeFilter(
              true, "status", value
            );
          }}
        >
          {
            deadlineStatuses.map(el => {
              const formatDesc= intl.formatMessage({id: el.desc});
              return <Option key={el.key} value={el.key} desc={el.desc}>
                <Tooltip
                  color="rgb(0, 80, 117)" 
                  getPopupContainer={trigger => trigger.parentNode.parentNode.parentNode} 
                  title={formatDesc}
                > 
                  {formatDesc}
                </Tooltip>
              </Option>;
            })
          }              
        </Select>; 
      } 
          
      let dataVal = renderStatus(obj);
      if (obj?.payment?.step === "collected" || obj?.payment?.step === "paid" || obj?.payment?.step === "rebated") {
        dataVal = (<div><div>{dataVal}</div>
          <div style={{ color: "#5a6872", marginLeft: "5px" }}>
            {obj.payment?.execution?.date ? "il " + moment(obj.payment?.execution?.date).format("DD/MM/YYYY") : null}
          </div></div>);
      }
           
      return dataVal;
    }          
  },
  {
    title: intl.formatMessage({id: "deadlines.table.isRead"}),
    dataIndex: "isRead",
    key: "isRead",
    width: 70,
    hidden: customersView ? true : false,
    render: (value, obj) => {                                  
      return value === "final" ?  null :   
        value === "initial" ?
          <Select     
            className="theadSelect"
            getPopupContainer={trigger => trigger.parentNode.parentNode}
            style={{ width: "70px", margin: "8px" }}
            allowClear={true}                                 
            placeholder={<FormattedMessage id="all"/>}
            onChange={(value) => {
              onChangeFilter(
                true, "viewed", value
              );
            }}
          >
            {
              deadlineSeenTypes.map(el => {
                return <Option key={el.key} value={el.key}>
                  <Tooltip
                    color="rgb(0, 80, 117)" 
                    getPopupContainer={trigger => trigger.parentNode.parentNode.parentNode} 
                    title={el.desc}> {el.desc}</Tooltip>
                </Option>;
              })
            }              
          </Select>  
          :

          (<div style={{textAlign: "center"}}><FontAwesomeIcon
            icon={["fas", "check-circle"]}
            style={{ color: obj?.status?.viewed ? "#8bc34a" : "#b2b6b7" }}
          /></div>);
    }   
     
  },
  {
    title: "",
    dataIndex: "actions",
    key: "actions",
    render: (value, obj) => {     
      if (value === "initial" || value === "final"){
        return null;
      }     
      const bellsIconVisibility =
        obj?.status?.confirmed &&
        obj.scope === "fiscal_social_security" &&
              ((obj?.payment?.status === "due" &&
              obj.amount < 0 &&
              obj.payment.type === "item_pays") ||
                (!obj.status.authorized &&
                  !obj?.status?.rejected &&
                  (obj.payment.type === "manager_pays" ||
                  obj.payment.type === "manager_charge")));

      const menuItems = buildMenuActionItems(obj, dispatch);

      return (           
        <div style={{display: "flex", width: "100%"}}>
          { !customersView &&
              <div>
                <Tooltip
                  getPopupContainer={trigger => trigger.parentNode.parentNode}
                  color="rgb(0, 80, 117)"                  
                  onClick={() => {
                    if (!bellsIconVisibility) return null;
                    setOpenSolicitDialog(true);
                    setSolicitRagioneSociale(obj.itemId);
                    setSolicitDeadlineId(obj.key);
                    return null;
                  /*
                  if (bellsIconVisibility) {
                    setOpenSolicitDialog(dialogVisible);
                    setRagSocCompany(ragioneSociale);
                    setDeadlineId(obj.key);
                    if (!dialogVisible) {
                      sendNotifyToCompany(obj.key);
                    }
                  }
                  */
                  }}
                  placement="top"
                  title={
                    bellsIconVisibility ? (
                      <FormattedMessage id="deadlines.pages.table.solicitDeadline" />
                    ) : null
                  }
                >                
                  <FontAwesomeIcon
                    style={{
                      color: bellsIconVisibility ? "#0090d1" : "#86899d",
                      fontSize: "16px",
                      margin: "10px 8px",
                      cursor: bellsIconVisibility ? "pointer" : "default"
                    }}
                    icon={["far", "bells"]}
                  />               
                </Tooltip>
              
              </div>
          }
          <div>
            {obj.notesCount > 0 && (
              <div
                style={{
                  color: "#0090d1",
                  fontSize: "14px",
                  position: "absolute",
                  marginTop: "-1px",
                  background: "white",
                  marginLeft: "24px",
                  paddingLeft: "3px",
                  height: "20px"
                }}
                onClick={() => {
                  navigate(`/scadenza/${obj.key}`,
                    {state: {
                      // activeTab: 0,
                      // isLoading: isLoading,
                      hasMoreItems: hasMoreItems,
                      queryParameters: queryParameters,
                      fromSchedaCliente: myType === "STUDIO" && customersView ? true : false,
                      fromList: true,
                      // tengo traccia dello scroll della lista
                      scrollTop: document.querySelector(".tableAreaScrollable").scrollTop,
                      scrollParentTop: document.querySelector(".dbx-main-page-container").scrollTop
                    }});
                }}
              >
                {obj.notesCount}
              </div>
            )}
            <FontAwesomeIcon
              icon={["far", "comment-alt"]}
              style={{
                color: "#0090d1",
                fontSize: "16px",
                margin: "10px 8px",
                cursor: "pointer"
              }}
            />
          </div>
          <div>
            <Tooltip
              getPopupContainer={trigger => trigger.parentNode.parentNode}
              color="rgb(0, 80, 117)"
              arrowPointAtCenter={true}              
              onClick={() => {
                navigate(`/scadenza/${obj.key}`,
                  {state: {
                    // activeTab: 0,
                    // isLoading: isLoading,
                    hasMoreItems: hasMoreItems,
                    queryParameters: queryParameters,
                    fromSchedaCliente: myType === "STUDIO" && customersView ? true : false,
                    fromList: true,
                    // tengo traccia dello scroll della lista
                    scrollTop: document.querySelector(".tableAreaScrollable").scrollTop,
                    scrollParentTop: document.querySelector(".dbx-main-page-container").scrollTop
                  }});
              }                
              }
              placement="topRight"
              overlayClassName="deadlineDetailIcon"
              title={<FormattedMessage id="deadlines.showDetail" />}
            >
              <FontAwesomeIcon
                icon={["far", "arrow-right"]}
                style={{
                  color: "#0090d1",
                  fontSize: "16px",
                  margin: "10px 8px",
                  cursor: "pointer"
                }}
              />
            </Tooltip>
          </div>
          {
            !customersView &&
              <div className="menuDeadlineRow">          
                {(menuItems.length > 0) ?            
                  <Dropdown
                    arrow={{pointAtCenter: true}}
                    placement="bottomRight"                 
                    getPopupContainer={trigger => trigger.parentNode.parentNode}
                    key={"dropdown_" + obj.key}
                    trigger={["click"]}
                    overlay={
                      <Menu style={{ fontSize: "16px" }}>{menuItems}</Menu>
                    }
                  >
                    <FontAwesomeIcon
                      icon={["far", "ellipsis-v"]}
                      style={{
                        color: "#0090d1",
                        fontSize: "20px",
                        margin: "10px 8px",
                        cursor: "pointer"
                      }}
                    />
                  </Dropdown>              
                  : null            
                }
              </div>
          }
        </div>
      );
    }      
  }
];